import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "query", "sort", "list", "row", "empty", "count"]

  open() {
    if (!this.dialogTarget.open) this.dialogTarget.showModal()

    this.queryTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      row.hidden = !row.dataset.label.includes(query)
    })

    this.updateCount()
  }

  sort() {
    const mode = this.sortTarget.value
    const rows = [...this.rowTargets]

    rows.sort((left, right) => {
      if (mode === "alphabetical") {
        return left.dataset.label.localeCompare(right.dataset.label)
      }

      const field = mode === "recent" ? "recentCount" : "count"
      const difference = Number(right.dataset[field]) - Number(left.dataset[field])
      return difference || left.dataset.label.localeCompare(right.dataset.label)
    })

    rows.forEach((row) => this.listTarget.insertBefore(row, this.emptyTarget))
  }

  updateCount() {
    const visible = this.rowTargets.filter((row) => !row.hidden).length
    const total = this.rowTargets.length

    this.countTarget.textContent = `Showing ${visible} of ${total}`
    this.emptyTarget.classList.toggle("hidden", visible !== 0)
  }
}
